'use client';

import { Button } from '@/d/components/ui/button';
import { createClientComponentClient } from '@supabase/auth-helpers-nextjs';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useEffect, useState, useRef } from 'react';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  const supabase = createClientComponentClient();
  const [errorHash, setErrorHash] = useState<string>('');
  const errorLogged = useRef(false);
  const router = useRouter();

  useEffect(() => {
    const logError = async () => {
      if (errorLogged.current) return;

      try {
        const hash = crypto.randomUUID();

        setErrorHash(hash);

        await supabase.from('web_error_logs').insert({
          message: error.message,
          stack: error.stack,
          digest: error.digest,
          timestamp: new Date().toISOString(),
          url: window.location.href,
          user_agent: window.navigator.userAgent,
          error_hash: hash,
        });

        errorLogged.current = true;
      } catch (logError) {
        console.error('Failed to log error:', logError);
      }
    };

    logError();
  }, [error, supabase]);
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-br from-[#f8f6fd] via-white to-transparent">
      <div className="flex flex-col items-center justify-center mb-10 gap-2 align-middle content-center">
        <Image src="/images/logo.png" width={50} height={50} alt="logo" />
        <h1 className="scroll-m-20 text-2xl font-extrabold tracking-tight lg:text-2xl mb-2">
          Healmind
        </h1>
      </div>

      <div className="container max-w-lg mx-auto p-6 bg-white rounded-lg gap-5 flex flex-col items-center justify-center ">
        <h1 className="text-xl font-bold">¡Algo salió mal!</h1>
        <h2 className="text-md">
          Pero no te preocupes, estamos trabajando en ello.
        </h2>
        <p className="text-sm">
          <b>Hash:</b> <code>{errorHash}</code>
        </p>

        <Button onClick={() => router.back()}>Ir atrás</Button>
      </div>
    </div>
  );
}
